import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import StyledCheckbox from '../../app/components/checkbox/StyledCheckbox';
import { ShopStyled } from '../shopSetting/assets/shopStyled';
import ProductsHeader from './ProductsHeader';
import { StyledProduct } from './assets/ProductStyled';
import {
  useAddCatalogueMutation,
  useAddProductToCatalogueMutation,
  useBulkDeleteFloristInventoryMutation,
  useBulkUpdateTopTagsMutation,
  useDeleteBulkProductMutation,
  useDeleteFloristInventoryMutation,
  useDeleteProductMutation,
  useDownVoteProductMutation,
  useGetAllFloristForCatalogFilterQuery,
  useGetFloristListOfCatalogProductsQuery,
  useLazyGetFloristInventoryQuery,
  useLazyGetProductsQuery,
  useRemoveProductFromCatalogueMutation,
  useUpdateProductStatusMutation,
  useUpdateProductStockStatusMutation,
  useUpVoteProductMutation,
} from './productsApiSlice';
import NewTrashIcon from '../../app/components/svgIcons/NewTrashIcon';
import StyledText from '../../app/components/styledComponents/StyledText';
import BaseEditIcon from '../../app/components/svgIcons/BaseEditIcon';
import { orderBy } from 'lodash';
import Table from '../../app/components/table/Table';
import StyledColoredTag from '../../app/components/styledComponents/StyledColoredTag';
import { toast } from 'react-toastify';
import ProductGridView from './ProductGridView';
import ProductListView from './ProductListView';
import DeleteConfirmation from '../../app/components/popups/DeleteConfirmation';
import { defaultListing, getImageUrl } from './assets/productsUtil';
import QuickAddIcon from '../../app/components/svgIcons/QuickAddIcon';
import { OverlayTrigger } from 'react-bootstrap';
import { StyledTooltip } from '../../app/components/styledComponents/StyledTooltip';
import StyledLoading from '../../app/components/loading/StyledLoading';
import { useSelector } from 'react-redux';
import { CATALOGUE, setPagination } from '../../app/services/paginationSlice';
import { useDispatch } from 'react-redux';
import EyeIcon from '../../app/components/svgIcons/EyeIcon';
import { selectBasicInformation } from '../auth/authSlice';
import CreateProduct from './CreateProduct';
import ProductDetail from './ProductDetail';
import { Offcanvas } from 'react-bootstrap';
import { useGetProductCategoriesMutation } from '../vendors/vendorsApiSlice';
import { setProductTags } from '../../app/services/productUtils';
import TagSelectorPopup from './TagSelectorPopup';
import { Container } from 'react-bootstrap';
import { setRefetchedAfterUpdate } from '../../app/services/products';
import AddIcon from '../../app/components/svgIcons/AddIcon';
import useAuth from '../../hooks/useAuth';
import ConfirmationModal from '../../app/components/popups/ConfirmationModal';
import {
  calculateServiceFee,
  getPrices,
  isAuthorized,
} from '../../utils/helper';
import styled from 'styled-components';
import ThumbUpIcon from '../../app/components/svgIcons/ThumbUpIcon';
import { getName } from '../../utils/helper';
import StyledSwitch from '../../app/components/styledComponents/StyledSwitch';
import ViewEyeIcon from '../../app/components/svgIcons/ViewEyeIcon';
import ProductAddIcon from '../../app/components/svgIcons/ProductAddIcon';
import { formatNumber } from '../../utils/helper';
import NewCloseIconn from '../../app/components/svgIcons/NewCloseIconn';

const Price = styled.div`
  font-family: ${({ theme }) => theme.fontFamily};
  font-size: 14px;
  font-weight: ${({ activated }) => (activated ? '600' : '500')};
  color: ${({ theme, activated }) => (activated ? theme.primary : '#666467')};
`;

const OffPrice = styled.div`
  text-decoration: line-through;
  font-family: ${({ theme }) => theme.fontFamily};
  font-size: 10px;
  font-weight: 500;
  line-height: 29px;
  letter-spacing: -0.20000000298023224px;
  text-align: center;
  color: ${({ theme }) => theme.bodyLight};
`;

const StyledThumbUpIconDiv = styled.div`
  background-color: ${({ theme }) => theme?.primary};
  border-radius: 50%;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 18px;
  width: 18px;
`;

const calculatePrice = (product, isCatalogue, forServiceFee) => {
  const variationKey = isCatalogue ? 'variationDTOS' : 'floristVariationDTOS';

  const {
    price,
    originalPrice,
    oldPrice,
    isDiscountApplied,
    isHolidayPriceApplied,
    discountPrice,
    holidayPrice
  } = getPrices(product, variationKey);

  if (forServiceFee) {
    return !isCatalogue && discountPrice && isDiscountApplied
      ? formatNumber(oldPrice)
      : formatNumber(price);
  }

  if (!forServiceFee) {
    return !isCatalogue ? (
      <div className="d-flex flex-row justify-content-center align-items-center">
        {((isDiscountApplied && discountPrice) || (isHolidayPriceApplied && holidayPrice)) && originalPrice ? (
          <Price activated={false}>${formatNumber(originalPrice)}</Price>
        ) : (
          <Price activated={true}>${formatNumber(price)} </Price>
        )}
      </div>
    ) : (
      <div>
        <Price>${formatNumber(price)} </Price>
      </div>
    );
  }
};

const Catalogue = ({
  isProduct,
  isCatalogue,
  isSelectProduct,
  isComingFromEditTemplate,
  onHandleButtonActionForTemplate,
  isComingForAddCatalogue,
}) => {
  const location = useLocation();
  const dispatch = useDispatch();
  const { cataloguePage } = useSelector((state) => state.pagination);
  const basicInfo = useSelector(selectBasicInformation);
  const { theme, previewTheme } = useSelector((state) => state.theme);
  const [listing, setListing] = useState({});
  const [productIdToDelete, setProductIdToDelete] = useState(null);
  const [isNotIntialRender, setIsNotIntialRender] = useState(false);
  const [view, setView] = useState(() => {
    return localStorage.getItem('productView') ?? 'grid';
  });
  const [products, setProducts] = useState({});
  const [upVoteProduct] = useUpVoteProductMutation();
  const [downVoteProduct] = useDownVoteProductMutation();
  const [showAll, setShowAll] = useState(null);
  const [tempData, setTempData] = useState([]);
  const [clickedIcon, setClickedIcon] = useState(null);
  const [showAddProductToCatalogueDilog, setshowAddProductToCatalogueDilog] =
    useState(null);
  const [isAddingToCatalogue, setIsAddingToCatalogue] = useState(false);
  const [addProductToCatalogue] = useAddProductToCatalogueMutation();
  const [updatingTag, setUpdatingTag] = useState(false);
  const navigate = useNavigate();
  const [floristData, setFloristData] = useState({});
  const[catalogLoading , setCatalogLoading] = useState({});
  const [addingFromCatalog , setAddingFromCatalog] = useState(false);
  const [lastAddedProduct , setLastAddedProduct] = useState({});

  const { data: productFlorists, isLoading: isProductFloristsFetching } =
    useGetFloristListOfCatalogProductsQuery();

  const { data: catalogFlorists, isLoading: isCatalogFloristsFetching } =
    useGetAllFloristForCatalogFilterQuery();

  useEffect(() => {
    if (productFlorists && catalogFlorists) {
      setFloristData(
        isProduct ? productFlorists?.objectData : catalogFlorists?.objectData,
      );
    }
  }, [isProduct, productFlorists, catalogFlorists]);

  const lazyFetchCall = isProduct
    ? useLazyGetFloristInventoryQuery
    : useLazyGetProductsQuery;

  const bulkDeleteCall = isProduct
    ? useBulkDeleteFloristInventoryMutation
    : useDeleteBulkProductMutation;

  const deleteCall = isProduct
    ? useDeleteFloristInventoryMutation
    : useDeleteProductMutation;

  const [getProducts, { isFetching }] = lazyFetchCall();

  useEffect(() => {
    localStorage.setItem('productView', view);
  }, [view]);

  const checkIsLiked = (product) => {
    if (
      tempData &&
      tempData?.length > 0 &&
      tempData?.find((item) => item.id === product.id)
    ) {
      const matchedProduct = tempData?.find((item) => item.id === product.id);
      if (!matchedProduct?.votes) {
        return false;
      } else {
        if (!Array.isArray(matchedProduct?.votes)) {
          return false;
        }

        // Find the vote object where floristId matches user?.id

        const voteEntry = matchedProduct.votes.find(
          (vote) =>
            vote.floristId === user?.floristId &&
            vote?.inventoryId === product?.id,
        );

        // If a matching voteEntry is found, return its vote status, otherwise return false
        return voteEntry ? voteEntry.vote : false;
      }
    } else {
      if (!product?.votes) {
        return false;
      } else {
        if (!Array.isArray(product?.votes)) {
          return false;
        }

        // Find the vote object where floristId matches user?.id
        const voteEntry = product.votes.find(
          (vote) => vote.floristId === user?.floristId,
        );

        // If a matching voteEntry is found, return its vote status, otherwise return false
        return voteEntry ? voteEntry.vote : false;
      }
    }
  };

  const setTempProductData = (product, data) => {
    const productData = { ...product };
    const votes = [...(product?.votes || [])];
    const voteIndex = votes.findIndex((vote) => vote.id === data.id);

    if (data.vote === false) {
      if (voteIndex !== -1) {
        votes.splice(voteIndex, 1);
      }
    } else if (data.vote === true) {
      if (voteIndex === -1) {
        votes.push(data);
      }
    }
    productData.votes = votes;

    // Update or add the product object in the tempData array
    setTempData((prevTempData) => {
      const index = prevTempData.findIndex(
        (item) => item.id === productData.id,
      );
      if (index !== -1) {
        // Update existing product data
        const newTempData = [...prevTempData];
        newTempData[index] = productData;
        return newTempData;
      } else {
        // Add new product data
        return [...prevTempData, productData];
      }
    });
  };

  const handleClick = (id, product) => {
    if (checkIsLiked(product)) {
      downVoteProduct(id)
        .then((data) => {
          if (!data?.error) {
            toast.success('Removed Successfully');
            setTempProductData(product, data?.data?.objectData);
          }
        })
        .catch((error) => {
          console.error('Error downvoting product:', error);
        });
    } else {
      upVoteProduct(id)
        .then((data) => {
          if (!data?.error) {
            toast.success('Product Upvoted Successfully');
            setTimeout(() => setClickedIcon(null), 500); // reset the clicked icon id after the animation duration
            setTempProductData(product, data?.data?.objectData);
          }
        })
        .catch((error) => {
          console.error('Error upvoting product:', error);
          setTimeout(() => setClickedIcon(null), 500); // reset the clicked icon id after the animation duration
        });
      setClickedIcon(id); // set the clicked icon id
    }
  };

  const fetchProductVotes = (product) => {
    if (
      tempData.length > 0 &&
      tempData?.find((item) => item.id === product.id)
    ) {
      const matchedProduct = tempData?.find((item) => item.id === product.id);
      if (matchedProduct?.votes) {
        return matchedProduct?.votes;
      } else {
        return [];
      }
    } else if (product) {
      return !product?.votes ? [] : product?.votes;
    } else {
      return [];
    }
  };

  const fetchProducts = async () => {
    const commonFlorists =
    listing?.contributedFloristId?.filter((florist) =>
      floristData &&
      Object.keys(floristData).some(
        (key) => Number(key) === Number(florist)
      )
    ) || [];

    
    try {
      const { data } = await getProducts({
        size: listing?.size,
        page: listing?.page || 0,
        filter: JSON.stringify({
          categoryDTO: listing?.category?.map((c) => c?.id) || undefined,
          ...(listing?.minVotes !== '' &&
            listing?.minVotes !== undefined && { minVotes: listing.minVotes }),
          ...(listing?.minSold !== '' &&
            listing?.minSold !== undefined && { minSold: listing.minSold }),
          ...(listing?.startDate !== undefined && {
            startDate: listing?.startDate,
          }),
          ...(listing?.endDate !== undefined && { endDate: listing?.endDate }),
          ...(listing?.soldStartDate !== undefined && {
            soldStartDate: listing?.soldStartDate,
          }),
          ...(listing?.soldEndDate !== undefined && {
            soldEndDate: listing?.soldEndDate,
          }),
          search: listing?.search || undefined,

          ...(listing?.mostUpVoted && { mostUpVoted: true }),
          ...(listing?.recentlyAdded && { recentlyAdded: true }),
          ...(listing?.mostSold && { mostSold: true }),

          floristInventoryTagDTOS:
            listing?.tags?.map((t) => t?.id) || undefined,
          price: {
            min: listing?.price?.[0] || undefined,
            max: listing?.price?.[1] !== 1000 ? listing?.price?.[1] : undefined,
          },
          ...(commonFlorists &&
            commonFlorists.length > 0 && {
              contributedFloristId: commonFlorists,
            }),
          ...(!isCatalogue && {
            stockStatus: listing.stockStatus,
            ...(listing.variationStockStatus
              ? { variationStockStatus: listing.variationStockStatus }
              : {}),
            deactivated: listing.deactivated,
            ...(listing.hidden ? { hidden: listing.hidden } : {}),
            ...(listing.localDeliveryOnly
              ? { localDeliveryOnly: listing.localDeliveryOnly }
              : {}),
            ...(listing.onlyMe ? { onlyMe: listing.onlyMe } : {}),
            ...(listing.availabilityDateSet
              ? { availabilityDateSet: listing.availabilityDateSet }
              : {}),
          }),
          ...((isProduct || (isSelectProduct && isCatalogue)) &&
            listing.Catalog.includes('contributed') && {
              contributed: listing.Catalog.includes('contributed'),
            }),
          ...((isProduct || (isSelectProduct && isCatalogue)) &&
            listing.Catalog.includes('catalogItem') && {
              catalogItem: listing.Catalog.includes('catalogItem'),
            }),
        }),
      });

      setProducts(data);
      if (updatingTag) {
        setUpdatingTag(false);
      }
      if(addingFromCatalog){
        setAddingFromCatalog(false);
      }
      setCatalogLoading((prev) => ({ ...prev, [lastAddedProduct?.id]: false }));
    } catch (error) {}
  };

  useEffect(() => {
    fetchProducts();
  }, [listing]);

  const [addCatalogueAPI] = useAddCatalogueMutation();
  const [showDeleteConfirmation, setShowDeleteConfirmation] = useState(0);

  const [deleteProductAPI] = deleteCall();
  const [bulkdeleteProductAPI] = bulkDeleteCall();
  const [bulkUpdateTags] = useBulkUpdateTopTagsMutation();
  const [selectedProducts, setSelectedProducts] = useState([]);
  const [viewTypeFromTemplate, setViewTypeFromTemplate] = useState(undefined);
  const [productEditId, serProductEditId] = useState(undefined);
  const [showRightPreview, setShowRightPreview] = useState(false);
  const [
    showRemoveItemFromCatalogueDilog,
    setshowRemoveItemFromCatalogueDilog,
  ] = useState(null);
  const [isRemovingFromCatalogue, setIsRemovingFromCatalogue] = useState(false);
  const [updateProductStatus] = useUpdateProductStatusMutation();
  const [updateProductStockStatus] = useUpdateProductStockStatusMutation();
  const [openUpdateStatusModal, setOpenUpdateStatusModal] = useState(null);
  const [updateStockStatusModal, setUpdateStockStatusModal] = useState(null);
  const [selectedProduct, setSelectedProduct] = useState(undefined);
  const [addtoMyProducts, setAddtoMyProducts] = useState(false);
  const [removeProductFromCatalogue] = useRemoveProductFromCatalogueMutation();
  const [getProductCategories] = useGetProductCategoriesMutation();
  const { user } = useAuth();

  const userPermissions = useSelector(
    (state) => state?.authorization?.userPermissions,
  );

  const has_permission_to_edit = isAuthorized(userPermissions, 'edit_product');
  const has_permission_to_delete = isAuthorized(
    userPermissions,
    'can_delete_product',
  );
  const has_permission_to_catalog = isAuthorized(
    userPermissions,
    'can_contribute_to_catalog',
  );
  const has_permission_to_remove_catalog = isAuthorized(
    userPermissions,
    'can_remove_from_catalog',
  );

  const getProductTags = async () => {
    try {
      const { data } = await getProductCategories({
        page: 0,
        size: 1000,
      });

      const options = await data?.options?.map((option) => ({
        ...option,
        value: option.title,
        label: option.title,
      }));

      dispatch(setProductTags(options));
    } catch (error) {}
  };
  const handleRemoveItemFromCatalogue = () => {
    setIsRemovingFromCatalogue(true);
    removeProductFromCatalogue(showRemoveItemFromCatalogueDilog?.id)
      .then((data) => {
        if (!data?.error) {
          toast.success('Product Removed from Catalogue Successfully');
          refetch();
        }
      })
      .catch((error) => {
        console.error('Error adding Removing from Catalogue:', error);
      });
    refetch();
    setIsRemovingFromCatalogue(false);
    setshowRemoveItemFromCatalogueDilog(null);
  };

  const handleUpdateStatus = (product) => {
    setUpdatingTag(true);
    updateProductStatus({
      activate: !product?.activated,
      inventoryDTOS: [{ id: product?.id }],
    })
      .then((data) => {
        if (!data?.error) {
          toast.success('Product Status Updated Successfully');
          refetch();
        }
      })
      .catch((error) => {
        console.error('Error updating product status:', error);
      });
  };

  const handleUpdateStockStatus = (product) => {
        setUpdatingTag(true);
        updateProductStockStatus({
          stockStatus: !product?.stockStatus,
          inventoryDTOS: [{ id: product?.id }],
        })
          .then((data) => {
            if (!data?.error) {
              toast.success('Product Status Updated Successfully');
              refetch();
            }
          })
          .catch((error) => {
            console.error('Error updating product status:', error);
          });
      };
  

  const handleBulkEditTopTags = async (data) => {
    setUpdatingTag(true);
    const res = await bulkUpdateTags({
      addTagDTOS: data?.addTagDTOS?.map((item) => ({ id: item.id })) ?? [],
      removeTagDTOS:
        data?.removeTagDTOS?.map((item) => ({ id: item.id })) ?? [],
      inventoryDTOS: data?.inventoryDTOS?.map((id) => ({ id })) ?? [],
    });
    if (!res.error) {
      toast.success('Tags updated successfully');
    }
    handleDataRefetch();
  };

  const refetch = () => {
    setListing((prevState) => {
      const storedFilters =
        JSON.parse(localStorage.getItem(`filterValues-${getName(location)}`)) ??
        defaultListing;
  
      return {
        ...storedFilters,
        page: prevState.page ?? defaultListing.page, // Keep previous "page" or fallback to defaultListing
      };
    });
  };

  const handleDataRefetch = () => {
    refetch();
    setSelectedProducts([]);
  };

  useEffect(() => {
    getProductTags();
  }, []);

  useEffect(() => {
    setListing({
      ...(JSON.parse(
        localStorage.getItem(`filterValues-${getName(location)}`),
      ) ?? defaultListing),
      // page: cataloguePage,
    });
    setSelectedProducts([]);
  }, [location.pathname]);

  const handlePerPageChange = async (size) => {
    setListing((prevState) => ({
      ...prevState,
      page: 0,
      size,
    }));
  };

  const handlePageChange = ({ selected }) => {
    if (location.pathname === '/settings/products') {
      dispatch(setPagination({ data: selected, action: CATALOGUE }));
    }
    setListing((prevState) => ({
      ...prevState,
      page: selected,
    }));
  };

  const handleProductSelection = (productId, isSelected) => {
    setSelectedProducts((prevProducts) =>
      isSelected
        ? [...prevProducts, productId]
        : prevProducts.filter((id) => id !== productId),
    );
  };

  const handleAllProductsSelection = (isSelected) => {
    if (isCatalogue) {
      setSelectedProducts(
        isSelected
          ? products?.objectData?.content
              ?.filter((p) => !p.catalogItem)
              ?.map(({ id }) => id)
          : [],
      );
      return;
    }
    setSelectedProducts(
      isSelected ? products?.objectData?.content?.map(({ id }) => id) : [],
    );
  };

  const handleAddToCatalogue = (product) => {
    setIsAddingToCatalogue(true);
    addProductToCatalogue({ id: product?.id })
      .then((data) => {
        if (!data?.error) {
          toast.success('Product added to Catalogue Successfully');
          refetch();
        }
      })
      .catch((error) => {
        console.error('Error adding product to catalogue:', error);
      });
    setIsAddingToCatalogue(false);
    setshowAddProductToCatalogueDilog(null);
  };

  const column = [
    {
      id: 1,
      key: 'category',
      label: '',
      checkBox: (
        <StyledCheckbox
          style={{ display: 'inline-flex' }}
          borderColor={'icon'}
          bgColor={'primary'}
          value={products?.objectData?.content?.every(({ id }) =>
            selectedProducts?.includes(id),
          )}
          onChange={(e) => handleAllProductsSelection(e.target.checked)}
        />
      ),
      content: ({ categoryDTO, id, catalogItem, contributedFloristId }) => (
        <>
          <span className="product-information-heading d-block d-md-none">
            Category
          </span>

          <div
            className="d-flex gap-2 gap-md-4"
            style={{
              display: !isCatalogue ? 'flex' : 'none',
            }}
          >
            <OverlayTrigger
              overlay={
                <StyledTooltip>
                  {location.pathname === '/settings/products/catalog' &&
                  isCatalogue &&
                  user?.floristId === contributedFloristId
                    ? 'This item is already contributed by you'
                    : 'This item is already added to your Products'}
                </StyledTooltip>
              }
              {...((!isCatalogue || !catalogItem) &&
                !(
                  location.pathname === '/settings/products/catalog' &&
                  isCatalogue &&
                  user?.floristId === contributedFloristId
                ) && {
                  show: false,
                })}
            >
              <span>
                <StyledCheckbox
                  disabled={
                    location.pathname === '/settings/products/catalog' &&
                    isCatalogue &&
                    user?.floristId === contributedFloristId
                      ? true
                      : false || (isCatalogue && catalogItem)
                  }
                  bgColor={'primary'}
                  borderColor={'gray40'}
                  value={selectedProducts.includes(id)}
                  onChange={(e) => handleProductSelection(id, e.target.checked)}
                  style={{
                    zIndex: 1,
                  }}
                />
              </span>
            </OverlayTrigger>
            {/*   {!isCatalogue && (categoryDTO?.name ? categoryDTO?.name : '-')} */}
          </div>
        </>
      ),
    },

    {
      id: 2,
      key: 'product',
      label: 'Products',
      content: ({ itemName, ...product }) => {
        const votes = fetchProductVotes(product);
        return (
          <>
            <span className="product-information-heading d-block d-md-none">
              Products
            </span>
            <div
              className="product"
              style={{
                alignItems: isCatalogue ? 'flex-start' : 'center',
                position: 'relative',
              }}
            >
              <img
                loading="lazy"
                src={getImageUrl(product, isCatalogue)}
                alt={itemName}
              />
              <span>
                <div
                  style={{ cursor: 'pointer' }}
                  onClick={() => {
                    setSelectedProduct(product);
                    setShowRightPreview(true);
                  }}
                >
                  {itemName}
                  {isCatalogue ? (
                    <div
                      style={{
                        zIndex: 1,
                        cursor: 'pointer',
                        alignSelf: 'flex-end',
                        position: 'absolute',
                        bottom: '5px',
                      }}
                      className="d-flex flex-row justify-content-start align-items-center p-0"
                    >
                      <OverlayTrigger
                        overlay={<StyledTooltip>Total Views</StyledTooltip>}
                      >
                        <div
                          style={{ cursor: 'pointer' }}
                          className="d-flex flex-row align-items-center justify-content-center"
                        >
                          <ViewEyeIcon size={18} color={theme?.primary} />
                          <StyledText
                            className="mx-1"
                            style={{ marginBottom: 0 }}
                            color={'#333333'}
                            $fontSize={'12px'}
                          >
                            {product?.customerViews ?? 0}
                          </StyledText>
                        </div>
                      </OverlayTrigger>

                      <OverlayTrigger
                        overlay={<StyledTooltip>Total Adds</StyledTooltip>}
                      >
                        <div
                          style={{ cursor: 'pointer' }}
                          className="mx-1 d-flex flex-row align-items-center justify-content-center"
                        >
                          <ProductAddIcon
                            size={25}
                            className="m-0"
                            color={theme?.primary}
                          />
                          <StyledText
                            $fontSize={'12px'}
                            style={{ marginBottom: 0 }}
                            color={'#333333'}
                          >
                            {product?.addedByFlorists ?? 0}
                          </StyledText>
                        </div>
                      </OverlayTrigger>

                      <div style={{ marginLeft: '5px' }}>
                        <OverlayTrigger
                          overlay={
                            <StyledTooltip>
                              {votes && votes.length > 0 ? (
                                <div>
                                  {showAll === product?.id
                                    ? votes
                                    : votes?.slice(0, 10).map((vote, index) => (
                                        <div
                                          key={index}
                                          style={{
                                            textAlign: 'left',
                                          }}
                                        >
                                          {vote?.companyName}
                                        </div>
                                      ))}
                                  {votes.length > 10 && (
                                    <button
                                      style={{
                                        marginTop: '10px',
                                        cursor: 'pointer',
                                      }}
                                      onClick={() =>
                                        setShowAll(
                                          showAll === product?.id
                                            ? null
                                            : product?.id,
                                        )
                                      }
                                    >
                                      {showAll === product?.id
                                        ? 'Show Less'
                                        : 'See More'}
                                    </button>
                                  )}
                                </div>
                              ) : (
                                <div>No votes available</div>
                              )}
                            </StyledTooltip>
                          }
                        >
                          <div className="d-flex align-items-center">
                            <StyledThumbUpIconDiv>
                              {' '}
                              <ThumbUpIcon
                                transperant={true}
                                size={8}
                                fillColor="white"
                                style={{ position: 'relative', top: '-1px' }}
                              />
                            </StyledThumbUpIconDiv>
                            <span
                              style={{
                                cursor: 'pointer',
                                fontSize: '12px',
                                marginLeft: '5px',
                              }}
                            >
                              {tempData &&
                              tempData?.find((item) => item.id === product.id)
                                ? tempData?.find(
                                    (item) => item.id === product.id,
                                  )?.votes?.length || 0
                                : votes?.length || 0}
                            </span>
                          </div>
                        </OverlayTrigger>
                      </div>
                    </div>
                  ) : product?.catalogItem ? (
                    product?.productRecognition ? (
                      <p
                        style={{
                          fontStyle: 'italic',
                          fontSize: '14px',
                          color: '#9E9C9C',
                        }}
                      >
                        Designed by {product?.productRecognition || ''}
                      </p>
                    ) : (
                      <p
                        style={{
                          fontStyle: 'italic',
                          fontSize: '14px',
                          color: '#9E9C9C',
                        }}
                      >
                        Designed by BoostFloral
                      </p>
                    )
                  ) : (
                    product?.contributed && (
                      <p
                        style={{
                          fontStyle: 'italic',
                          fontSize: '14px',
                          color: '#9E9C9C',
                        }}
                      >
                        Added to Catalog
                      </p>
                    )
                  )}
                </div>
              </span>
            </div>
          </>
        );
      },
    },

    {
      id: 3,
      key: 'description',
      label: 'Description',
      alignBody: '_wrap-text',
      content: (item) => (
        <>
          <span className="product-information-heading d-block d-md-none">
            Description
          </span>
          <span
            style={{
              maxWidth: '550px',
              display: 'inline-block',
              wordWrap: 'break-word',
            }}
            dangerouslySetInnerHTML={{
              __html: item?.description
                ? item.description.length > 300
                  ? item.description.substring(0, 300) + '...'
                  : item.description
                : '',
            }}
          />
        </>
      ),
    },

    {
      id: 4,
      key: 'price',
      label: 'Price($)',
      content: (item) => (
        <div
          style={{ position: !(isCatalogue && !isSelectProduct) && 'relative' }}
        >
          <span className="product-information-heading d-block d-md-none">
            Price ($)
          </span>
          {calculatePrice(item, isCatalogue, false)}
          {isCatalogue && isSelectProduct ? (
            <StyledText
              color={'primary'}
              fontSize={'18px'}
              className={`mb-0 margin-right mt-2`}
            >
              (Suggested Price)
            </StyledText>
          ) : (
            !(isCatalogue && !isSelectProduct) && (
              <StyledText
                color={'bodyLight'}
                $fontSize={'12px'}
                style={{
                  position: 'absolute',
                  width: 'max-content',
                  bottom: '-16px',
                  cursor: 'pointer',
                }}
                className={`mb-0 margin-right`}
              >
                <OverlayTrigger
                  overlay={
                    <StyledTooltip>
                      <span
                        style={{
                          fontSize: '12px',
                        }}
                      >
                        A service fee of $5.99 or 4%, whichever is higher, is
                        applied to each order. Florists can choose to pay this
                        fee from the received amount, or to apply it to the
                        customer during checkout (this means the customer pays
                        it). This fee covers the credit card processing and
                        servicing of the order.
                      </span>
                    </StyledTooltip>
                  }
                >
                  <span>
                    (services fee: $
                    {calculateServiceFee(
                      calculatePrice(item, isCatalogue, true),
                    )}
                    )
                  </span>
                </OverlayTrigger>
              </StyledText>
            )
          )}
        </div>
      ),
    },

    ...(isProduct
      ? [
          {
            id: 5,
            key: 'companyName',
            label: 'Stock Status',
            content: ({ stockStatus }) => (
              <>
                <span className="product-information-heading d-block d-md-none">
                  Stock Status
                </span>
                <StyledColoredTag
                  variant={stockStatus ? 'successTag' : 'dangerTag'}
                  className={`${stockStatus ? 'ms-md-4' : ''}`}
                >
                  {stockStatus ? 'In Stock' : 'Out of Stock'}
                </StyledColoredTag>
              </>
            ),
          },
        ]
      : []),

    ...(isProduct
      ? [
          {
            id: 6,
            key: 'holidayPrice',
            label: 'Alternate Prices',
            content: ({
              holidayPrice,
              discountPrice,
              discountPriceApplied,
              oldPrice,
              holidayPriceApplied,
            }) => (
              <div style={{ width: '150px' }} className="d-flex flex-column">
                <OverlayTrigger
                  overlay={<StyledTooltip>Discounted Price</StyledTooltip>}
                >
                  <Price
                    style={{ cursor: 'pointer' }}
                    activated={
                      discountPriceApplied && discountPrice ? true : false
                    }
                  >
                    {` DP - ${
                      discountPriceApplied && discountPrice
                        ? `$${discountPrice?.toFixed(2)} (Applied)`
                        : oldPrice
                        ? `$${oldPrice?.toFixed(2)}`
                        : 'NA'
                    }`}
                  </Price>
                </OverlayTrigger>
                <OverlayTrigger
                  overlay={<StyledTooltip>Holiday Price</StyledTooltip>}
                >
                  <Price
                    style={{ cursor: 'pointer' }}
                    activated={
                      holidayPriceApplied && holidayPrice ? true : false
                    }
                  >
                    {`
                    HP - ${holidayPrice ? `$${holidayPrice?.toFixed(2)}` : 'NA'}
                  ${
                    holidayPriceApplied && holidayPrice ? '(Applied)' : ''
                  }                
                  `}
                  </Price>
                </OverlayTrigger>
              </div>
            ),
          },
        ]
      : []),
    {
      id: 7,
      isChecked: true,
      label: 'Actions',
      content: (item) => (
        <>
          <span className="product-information-heading d-block d-md-none">
            Action
          </span>
          <div className="position-relative d-flex flex-row">
            {isProduct && (
              <StyledSwitch
                onClick={() => setShowRightPreview(false)}
                enableText="In Stock"
                height="25px"
                circleHeight={17}
                circleWidth={17}
                disableText="Out of Stock"
                width="112px"
                checked={item?.stockStatus}
                onChange={() => setUpdateStockStatusModal(item)}
              />
            )}
            {isProduct && (
              <StyledSwitch
                onClick={() => setShowRightPreview(false)}
                enableText="Active"
                height="25px"
                circleHeight={17}
                circleWidth={17}
                disableText="Inactive"
                width="87px"
                checked={item?.activated}
                onChange={() => setOpenUpdateStatusModal(item)}
              />
            )}
          </div>
          <div className="d-flex align-items-center position-relative">
            {isCatalogue &&
              user?.floristId !== item?.contributedFloristId &&
              item?.catalogItem && (
                <StyledColoredTag variant={'primaryGreen'} className={``}>
                  Added
                </StyledColoredTag>
              )}
            {!isSelectProduct && (
              <TagSelectorPopup
                product={item}
                handleBulkEditTopTags={handleBulkEditTopTags}
                isCatalogue={isCatalogue}
                refetch={refetch}
              />
            )}
            {isCatalogue &&
              (isSelectProduct ? (
                user?.floristId === item?.contributedFloristId ? (
                  <StyledText
                    color={'icon'}
                    className={`mb-0 ${
                      has_permission_to_remove_catalog
                        ? 'cursor-pointer'
                        : 'cursor-not-allowed opacity-50'
                    } margin-right`}
                    style={{
                      zIndex: 1,
                    }}
                    onClick={() => {
                      has_permission_to_remove_catalog &&
                        setshowRemoveItemFromCatalogueDilog(item);
                    }}
                  >
                    <OverlayTrigger
                      overlay={
                        <StyledTooltip>
                          {has_permission_to_remove_catalog
                            ? 'Remove Item from Catalog'
                            : 'You do not have permission to remove product from catalog'}
                        </StyledTooltip>
                      }
                    >
                      <span className={`ms-2 ms-md-3`}>
                        <NewTrashIcon />
                        <style>
                          {`
                          svg{
                          cursor:unset
                          }
                          `}
                        </style>
                      </span>
                    </OverlayTrigger>
                  </StyledText>
                ) : !item?.catalogItem ? (
                  <StyledText
                    style={{ minWidth: '60px' }}
                    color={'icon'}
                    className="mb-0 margin-right d-flex justify-content-center"
                  >
                    {catalogLoading[item?.id] ? (
                      <StyledLoading
                        minHeight={'2vh'}
                        style={{
                          height: '1.5rem',
                          width: '1.5rem',
                          marginLeft: '5px',
                        }}
                      />
                    ) : (
                      <OverlayTrigger
                        overlay={
                          <StyledTooltip>
                            {item.catalogItem
                              ? 'Product has already been added to the catalog'
                              : 'Quick Add to Products'}
                          </StyledTooltip>
                        }
                      >
                        <span
                          className={`ms-2 ms-md-3 ${
                            item.catalogItem
                              ? 'cursor-not-allowed opacity-50'
                              : 'cursor-pointer'
                          }`}
                          onClick={() => {
                            if (item.catalogItem) return;
                            onQuickAdd({ id: item.id });
                          }}
                        >
                          <QuickAddIcon />
                        </span>
                      </OverlayTrigger>
                    )}
                  </StyledText>
                ) : null
              ) : (
                <>
                  <StyledText
                    color={'icon'}
                    className="mb-0 cursor-pointer margin-right"
                    onClick={() => navigate(`${item.id}`)}
                    title="Edit Product"
                  >
                    <BaseEditIcon />
                  </StyledText>
                  <StyledText
                    color={'error'}
                    className="mb-0 cursor-pointer"
                    onClick={() => {
                      if(isProduct && item?.catalogItem){
                        setProductIdToDelete(item.id);
                        setShowDeleteConfirmation(3);
                      }
                      else {
                        setProductIdToDelete(item.id);
                        setShowDeleteConfirmation(1);
                      }
                    }}
                    title={
                      isProduct && item?.catalogItem
                        ? 'Remove catalog product from your products'
                        : 'Delete Product'
                    }
                  >
                    {isProduct && item?.catalogItem ? (
                      <NewCloseIconn color={'#d95454'} size={24} />
                    ) : (
                      <NewTrashIcon />
                    )}
                  </StyledText>
                </>
              ))}
            {!isCatalogue && (
              <>
                {!item?.catalogItem && !item.contributed && (
                  <StyledText
                    color={'icon'}
                    className={`mb-0 ${
                      has_permission_to_catalog
                        ? 'cursor-pointer'
                        : 'cursor-not-allowed opacity-50'
                    } margin-right`}
                    style={{
                      zIndex: 1,
                    }}
                    title={
                      has_permission_to_catalog
                        ? 'Add Product to Catalog'
                        : 'You do not have permission to add product to catalog'
                    }
                    onClick={() =>
                      has_permission_to_catalog &&
                      setshowAddProductToCatalogueDilog(item)
                    }
                  >
                    <AddIcon />
                  </StyledText>
                )}
                <StyledText
                  as="a"
                  color={'icon'}
                  className="mb-0 cursor-pointer margin-right"
                  href={
                    basicInfo?.subdomainUrl
                      ? `${basicInfo?.subdomainUrl}/products/${item.slug}`
                      : '#'
                  }
                  target="_blank"
                  title="View Product on Website"
                >
                 <EyeIcon />
                </StyledText>

                <StyledText
                  color={'icon'}
                  className={`mb-0 ${
                    has_permission_to_edit
                      ? 'cursor-pointer'
                      : 'cursor-not-allowed opacity-50'
                  } margin-right`}
                  onClick={() => {
                    if (has_permission_to_edit) {
                      if (isComingFromEditTemplate) {
                        setViewTypeFromTemplate('editproduct');
                        serProductEditId(item.id);
                        return;
                      }
                      navigate(`${item.id}`);
                    }
                  }}
                  title={
                    has_permission_to_edit
                      ? 'Edit Product'
                      : 'You do not have permission to edit product'
                  }
                >
                  <BaseEditIcon />
                  <style>
                    {`
                    svg{
                    cursor: ${
                      has_permission_to_delete
                        ? 'pointer'
                        : 'not-allowed !important'
                    };
                    }
                    `}
                  </style>
                </StyledText>
                <StyledText
                  color={'error'}
                  className={`mb-0 ${
                    has_permission_to_delete
                      ? 'cursor-pointer'
                      : 'cursor-not-allowed opacity-50'
                  }`}
                  onClick={() => {
                    if(!has_permission_to_delete){
                      return;
                    }
                    else {
                      if(isProduct && item?.catalogItem){
                        setProductIdToDelete(item.id);
                        setShowDeleteConfirmation(3);
                      }
                      else {
                        setProductIdToDelete(item.id);
                        setShowDeleteConfirmation(1);
                      }
                    }
                  }}
                  title={
                    has_permission_to_delete
                      ? isProduct && item?.catalogItem
                        ? 'Remove catalog product from your products'
                        : 'Delete Product'
                      : 'You do not have permission to delete product'
                  }
                >
                  {isProduct && item?.catalogItem ? (
                    <NewCloseIconn color={'#d95454'} size={24} />
                  ) : (
                    <NewTrashIcon />
                  )}
                  <style>
                    {`
                    svg{
                    cursor: ${
                      has_permission_to_delete
                        ? 'pointer'
                        : 'not-allowed !important'
                    };
                    }
                    `}
                  </style>
                </StyledText>
              </>
            )}

            {isCatalogue && isSelectProduct && (
              <StyledText
                className={`mb-0 cursor-pointer`}
                onClick={() => handleClick(item?.id, item)}
                style={{
                  zIndex: 1,
                  transition: 'all 0.3s ease-in-out',
                }}
              >
                <OverlayTrigger
                  overlay={
                    <StyledTooltip>
                      {checkIsLiked(item) ? 'Remove Vote' : 'Upvote'}
                    </StyledTooltip>
                  }
                >
                  <span className={`ms-2 ms-md-3 cursor-pointer`}>
                    <ThumbUpIcon
                      style={{
                        transition: ' transform 0.3s ease-in-out',
                      }}
                      className={clickedIcon === item?.id ? 'clicked' : ''}
                      transperant={!checkIsLiked(item)}
                      cuffColor={
                        previewTheme?.primary ?? theme?.primary ?? '#004CFF'
                      }
                    />
                    <style jsx>
                      {`
                        .clicked {
                          transform: scale(1.2) rotate(-10deg);
                        }
                      `}
                    </style>
                  </span>
                </OverlayTrigger>
              </StyledText>
            )}
          </div>
        </>
      ),
    },
  ];

  const onQuickAdd = async (id) => {
    setLastAddedProduct(id);
    setCatalogLoading((prev) => ({ ...prev, [id?.id]: true }));
    setAddingFromCatalog(true);
    try {
      const { data } = await addCatalogueAPI([id]);
      if (!data?.error) {
        toast.success(
          data?.description || 'Inventory Catalogue Saved Successfully',
        );
        isComingForAddCatalogue ? onHandleButtonActionForTemplate() : refetch();
      }
    } catch (error) {
      console.error(error);
    }
    // setCatalogLoading((prev) => ({ ...prev, [id?.id]: false }));
  };

  const handleDelete = async (id) => {
    const { data } = await deleteProductAPI(productIdToDelete || id);
    if (!data?.error) {
      toast.success(
        data?.description || 'Florist Inventory Deleted Successfully',
      );
      refetch();
      setShowDeleteConfirmation(0);
      setProductIdToDelete(null);
    }
  };

  const onDeleteProducts = async () => {
    if (selectedProducts?.length < 1) return;

    const res = await bulkdeleteProductAPI(selectedProducts);
    if (res.data) {
      toast.success('Selected products deleted successfully!');
      refetch();
      setShowDeleteConfirmation(0);
      setProductIdToDelete(null);
      setSelectedProducts([]);
    }
  };

  const handleSort = (sort) => {
    const newSortedProducts = orderBy(
      [...products?.objectData?.content],
      sort.path,
      sort.order.toLowerCase() || 'asc',
    );
    setProducts({
      ...products,
      objectData: {
        ...products?.objectData,
        content: newSortedProducts,
      },
    });
    setListing((prevState) => ({
      ...prevState,
      sortColumn: sort,
    }));
  };

  const productWithProgress =
    useSelector((state) => state.products)?.[
      isCatalogue ? 'inventoryProduct' : 'floristProduct'
    ] ?? null;

  const refetchedAfterUpdate =
    useSelector((state) => state.products.refetchedAfterUpdate) ?? true;

  useEffect(() => {
    if (!productWithProgress && !isFetching && !refetchedAfterUpdate) {
      setIsNotIntialRender(true);
      dispatch(
        setRefetchedAfterUpdate({
          refetchedAfterUpdate: true,
        }),
      );
      refetch();
      return;
    }

    if (productWithProgress) {
      setProducts((prev) => {
        const shallowCopy = [...(prev?.objectData?.content ?? [])];
        const index = shallowCopy.findIndex(
          (item) => item.id === productWithProgress.id,
        );
        if (index > -1) {
          shallowCopy.splice(index, 1, productWithProgress);
          return {
            ...prev,
            objectData: {
              ...(prev?.objectData ?? {}),
              content: shallowCopy,
            },
          };
        } else {
          const shallowCopy = [
            productWithProgress,
            ...(prev?.objectData?.content ?? []),
          ];
          return {
            ...prev,
            objectData: {
              ...(prev?.objectData ?? {}),
              content: shallowCopy,
            },
          };
        }
      });
    }
  }, [productWithProgress, isFetching]);

  return (
    <>
      {viewTypeFromTemplate && (
        <>
          {viewTypeFromTemplate === 'addproduct' && (
            <CreateProduct
              isCatalogue={isCatalogue}
              isFlorist
              isComingFromEditTemplate
              onHandleButtonActionForTemplate={() => {
                setViewTypeFromTemplate(undefined);
                refetch();
              }}
            />
          )}

          {viewTypeFromTemplate === 'viewproduct' && (
            <CreateProduct
              isCatalogue={isCatalogue}
              isFlorist
              isViewOnly
              isComingFromEditTemplate
              productId={productEditId}
              onHandleButtonActionForTemplate={() => {
                if (isComingForAddCatalogue)
                  setViewTypeFromTemplate('viewcatalouge');
                else setViewTypeFromTemplate(undefined);
                refetch();
              }}
            />
          )}

          {viewTypeFromTemplate === 'editproduct' && (
            <CreateProduct
              isCatalogue={isCatalogue}
              isFlorist
              isComingFromEditTemplate
              productId={productEditId}
              onHandleButtonActionForTemplate={() => {
                setViewTypeFromTemplate(undefined);
                refetch();
              }}
            />
          )}

          {viewTypeFromTemplate === 'viewcatalouge' && (
            <Catalogue
              isCatalogue
              isSelectProduct
              isComingFromEditTemplate
              isComingForAddCatalogue
              onHandleButtonActionForTemplate={() => {
                setViewTypeFromTemplate(undefined);
                onHandleButtonActionForTemplate &&
                  onHandleButtonActionForTemplate();
                refetch();
              }}
            />
          )}
        </>
      )}
      {!viewTypeFromTemplate && (
        <>
          <ShopStyled.PageWrap isFullWidth>
            <Container fluid>
              <div className="mb-3">
                <ProductsHeader
                floristData={floristData}
                isProductFloristsFetching={isProductFloristsFetching}
                 isCatalogFloristsFetching={isCatalogFloristsFetching}
                  setView={setView}
                  view={view}
                  isCatalogue={isCatalogue}
                  setListing={setListing}
                  listing={listing}
                  isProduct={isProduct}
                  isSelectProduct={isSelectProduct}
                  selectedProducts={selectedProducts}
                  refetch={handleDataRefetch}
                  setUpdatingTag={setUpdatingTag}
                  setSelectedProducts={setSelectedProducts}
                  handleBulkEditTopTags={handleBulkEditTopTags}
                  isComingFromEditTemplate={isComingFromEditTemplate}
                  onHandleButtonActionForTemplate={(type) => {
                    isComingForAddCatalogue
                      ? onHandleButtonActionForTemplate()
                      : setViewTypeFromTemplate(type);
                  }}
                  onDeleteProducts={() => {
                    setShowDeleteConfirmation(2);
                  }}
                  data={products}
                  getProductTags={getProductTags}
                  getName={getName}
                  addtoMyProducts={addtoMyProducts}
                  setAddtoMyProducts={setAddtoMyProducts}
                />
              </div>
              {(!addingFromCatalog &&
                !updatingTag &&
                isFetching &&
                !isNotIntialRender) ||
              addtoMyProducts ? (
                <StyledProduct.ProductsTable className="product-table">
                  <StyledLoading />
                </StyledProduct.ProductsTable>
              ) : (
                <StyledProduct.ProductsTable
                  className="product-table producTableOverflow"
                  padding={view !== 'table' ? '24px' : ''}
                >
                  {view === 'grid' && (
                    <ProductGridView
                      data={products?.objectData}
                      loading={isFetching}
                      deleteProduct={(id) => {
                        setProductIdToDelete(id);
                      }}
                      isCatalogue={isCatalogue}
                      onRefetch={handleDataRefetch}
                      action={{
                        handlePerPageChange,
                        handlePageChange,
                      }}
                      isProduct={isProduct}
                      setUpdatingTag={setUpdatingTag}
                      isSelectProduct={isSelectProduct}
                      onQuickAdd={onQuickAdd}
                      selectedProducts={selectedProducts}
                      handleProductSelection={handleProductSelection}
                      handleBulkEditTopTags={handleBulkEditTopTags}
                      isComingFromEditTemplate={isComingFromEditTemplate}
                      serProductEditId={serProductEditId}
                      onHandleButtonActionForTemplate={(type) => {
                        setViewTypeFromTemplate(type);
                      }}
                      changeInPageNumber={true}
                      catalogLoading={catalogLoading}
                      setShowDeleteConfirmation={setShowDeleteConfirmation}
                      handleAllProductsSelection={handleAllProductsSelection}
                      products={products}
                    />
                  )}

                  {view === 'list' && (
                    <ProductListView
                      data={products?.objectData}
                      loading={isFetching}
                      deleteProduct={(id) => {
                        setProductIdToDelete(id);
                      }}
                      isCatalogue={isCatalogue}
                      onRefetch={handleDataRefetch}
                      onQuickAdd={onQuickAdd}
                      action={{
                        handlePerPageChange,
                        handlePageChange,
                      }}
                      isProduct={isProduct}
                      setUpdatingTag={setUpdatingTag}
                      isSelectProduct={isSelectProduct}
                      handleBulkEditTopTags={handleBulkEditTopTags}
                      selectedProducts={selectedProducts}
                      handleProductSelection={handleProductSelection}
                      isComingFromEditTemplate={isComingFromEditTemplate}
                      serProductEditId={serProductEditId}
                      onHandleButtonActionForTemplate={(type) => {
                        setViewTypeFromTemplate(type);
                      }}
                      changeInPageNumber={true}
                      catalogLoading={catalogLoading}
                      setShowDeleteConfirmation={setShowDeleteConfirmation}
                      handleAllProductsSelection={handleAllProductsSelection}
                      products={products}
                    />
                  )}

                  {view === 'table' && (
                    <Table
                      sortColumn={listing.sortColumn}
                      onSort={handleSort}
                      className={'border-0'}
                      columns={column}
                      loading={isFetching && !addingFromCatalog}
                      data={products?.objectData}
                      action={{
                        handlePerPageChange,
                        handlePageChange,
                      }}
                      onRefetch={handleDataRefetch}
                      isCatalogue={isCatalogue}
                      updatingTag={updatingTag}
                      changeInPageNumber={true}
                    />
                  )}
                </StyledProduct.ProductsTable>
              )}
            </Container>
          </ShopStyled.PageWrap>

          <style>
            {`
              .producTableOverflow {
                overflow: visible !important;
                }
              `}
          </style>

          <ConfirmationModal
            show={!showAddProductToCatalogueDilog ? false : true}
            isLoading={isAddingToCatalogue}
            heading={'Add this Product to the Catalog'}
            bodyText={`This allows other Florists to find this Product in the Catalog, add it to their Product List, and offer it for sale on their website.  You can remove it from the Catalog at any time.`}
            bodyText2={`By submitting this product and its associated images 
into the public directory, the Florist confirms that they 
own all rights to the content and images and hereby 
grant permission for their use and sale by other Florists.`}
            ButtonText={'Add'}
            onClick={() => {
              !isAddingToCatalogue &&
                handleAddToCatalogue(showAddProductToCatalogueDilog);
            }}
            onCancel={() => {
              setshowAddProductToCatalogueDilog(null);
              setIsAddingToCatalogue(false);
            }}
          />

          <DeleteConfirmation
            show={!showRemoveItemFromCatalogueDilog ? false : true}
            isLoading={isRemovingFromCatalogue}
            bodyText={'This will remove this Product from the Catalog.'}
            onDelete={handleRemoveItemFromCatalogue}
            onCancel={() => {
              setshowRemoveItemFromCatalogueDilog(null);
            }}
          />

          <ConfirmationModal
            show={openUpdateStatusModal}
            bodyText={`${
              openUpdateStatusModal?.activated
                ? 'This will remove the Product from all website pages.'
                : 'This will activate the Product and will be seen on all website pages.'
            }`}
            ButtonText={
              openUpdateStatusModal?.activated ? 'Deactivate' : 'Activate'
            }
            onClick={() => {
              handleUpdateStatus(openUpdateStatusModal);
              setOpenUpdateStatusModal(null);
            }}
            onCancel={() => {
              setOpenUpdateStatusModal(null);
            }}
          />

          <ConfirmationModal
            show={updateStockStatusModal !== null}
            bodyText={`${
              updateStockStatusModal?.stockStatus
                ? 'If you mark this product as out of stock, all the variation of this product will be marked as out of stock.'
                : 'This product will now be available for purchase.'
            }`}
            ButtonText={'Confirm'}
            onClick={() => {
              handleUpdateStockStatus(updateStockStatusModal);
              setUpdateStockStatusModal(null);
            }}
            onCancel={() => {
              setUpdateStockStatusModal(null);
            }}
          />

          <DeleteConfirmation
            show={showDeleteConfirmation > 0}
            bodyText={
              showDeleteConfirmation === 2
                ? 'Do you want to delete these record? This process cannot be undone.'
                : showDeleteConfirmation === 3
                ? 'This will remove the Catalog product from your Product List, but it can be re-added in the future'
                : ''
            }
            onDelete={
              showDeleteConfirmation === 2 ? onDeleteProducts : handleDelete
            }
            deleteButtonText={
              showDeleteConfirmation === 3 ? 'Remove' : 'Delete'
            }
            onCancel={() => {
              setShowDeleteConfirmation(0);
              setProductIdToDelete(null);
              setSelectedProducts([]);
            }}
          />
          <Offcanvas
            show={showRightPreview}
            onHide={() => setShowRightPreview(false)}
            placement={'end'}
            style={{ width: '50%' }}
          >
            <Offcanvas.Header closeButton>
              <Offcanvas.Title>Product Detail</Offcanvas.Title>
            </Offcanvas.Header>
            <Offcanvas.Body>
              <ProductDetail
                productId={selectedProduct?.id}
                isCatalogue={isCatalogue}
                isProduct={isProduct}
                isSelectProduct={isSelectProduct}
                addToProductsHandler={() => {
                  if (selectedProduct?.catalogItem) return;
                  onQuickAdd({ id: selectedProduct?.id });
                }}
              />
            </Offcanvas.Body>
          </Offcanvas>
        </>
      )}
    </>
  );
};

export default Catalogue;
